/* unplugin-vue-components disabled */import { render, staticRenderFns } from "./close.vue?vue&type=template&id=3fed30d5&"
var script = {}


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  ,true
)

export default component.exports